import { DatePicker as CXDatePicker } from '@sanlamcx/react-ui-next-date-picker-v2';

type DatePicker = typeof CXDatePicker;
export const DatePicker: DatePicker = CXDatePicker;
